import { render } from "./BaseMultiSelect.vue?vue&type=template&id=567aa761"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__